module.exports = __webpack_public_path__ + "static/media/Twitter.6cb28118.svg";